type CookieOptions = {
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  expires?: Date | number;
};

export const CookieManager = {
  set(name: string, value: string, options: CookieOptions = {}) {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (options.expires) {
      if (typeof options.expires === 'number') {
        const d = new Date();
        d.setTime(d.getTime() + options.expires * 24 * 60 * 60 * 1000);
        options.expires = d;
      }
      cookieString += `;expires=${options.expires.toUTCString()}`;
    }

    if (options.path) cookieString += `;path=${options.path}`;
    if (options.domain) cookieString += `;domain=${options.domain}`;
    if (options.secure) cookieString += ';secure';
    if (options.sameSite) cookieString += `;samesite=${options.sameSite}`;

    document.cookie = cookieString;
  },

  get(name: string): string | null {
    const nameEQ = encodeURIComponent(name) + '=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      let c = cookie;
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },

  remove(name: string, options: CookieOptions = {}) {
    this.set(name, '', { ...options, expires: -1 });
  }
}; 